import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function KitDeliveryListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.kit.delivery.list);
  };

  return (
    <MainMenuItem
      itemTitleString="発送履歴を見る"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default KitDeliveryListMenuItem;
